<template>
  <div>
    <h3>{{ $t("navigation." + constants.ROUTE_NEW_FOOD) }}</h3>
    <FoodForm
      @foodSubmitted="createFood"
      :preselectCategories="preselectCategories"
    />
  </div>
</template>

<script>
import * as constants from "./../../constants";
import FoodForm from "./FoodForm";

export default {
  name: "NewFood",
  data() {
    return {
      constants
    };
  },
  props: {
    preselectCategories: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: { FoodForm },
  methods: {
    createFood() {
      this.$router.push({
        name: constants.ROUTE_FOOD,
        params: { forceReload: true }
      });
    }
  }
};
</script>

<style scoped></style>
